import { I as i } from "../../constants-DeVuDy8J.js";
import { openBlock as l, createElementBlock as d, normalizeClass as n, createElementVNode as o } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconSwitchToHd",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, h = ["aria-label", "data-qa", "aria-hidden"];
function m(e, t, r, u, _, a) {
  return l(), d("svg", {
    "aria-label": r.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--switch-to-hd"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Switch To Hd",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [...t[0] || (t[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.896.646a.5.5 0 0 1 .708 0l1.25 1.25a.5.5 0 0 1 0 .708l-1.25 1.25a.5.5 0 1 1-.708-.708l.397-.396H2.5a.5.5 0 0 1 0-1h1.793l-.397-.396a.5.5 0 0 1 0-.708ZM7.5 2a.5.5 0 0 1 .5-.5h2c.826 0 1.5.674 1.5 1.5v7c0 .826-.674 1.5-1.5 1.5H3A1.5 1.5 0 0 1 1.5 10V8.5a.5.5 0 0 1 1 0V10a.5.5 0 0 0 .5.5h7c.274 0 .5-.226.5-.5V3c0-.274-.226-.5-.5-.5H8a.5.5 0 0 1-.5-.5ZM2.604 3.146a.5.5 0 0 1 0 .708l-.397.396H4a.5.5 0 0 1 0 1H2.207l.397.396a.5.5 0 1 1-.708.708l-1.25-1.25a.5.5 0 0 1 0-.708l1.25-1.25a.5.5 0 0 1 .708 0ZM5.75 4.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0V7h-1v1a.5.5 0 0 1-1 0V6.5a.5.5 0 0 1 .5-.5h1.5V5a.5.5 0 0 1 .5-.5Zm1 .5a.5.5 0 0 1 .5-.5h1A1.5 1.5 0 0 1 9.75 6v1a1.5 1.5 0 0 1-1.5 1.5h-1a.5.5 0 0 1-.5-.5V5Zm2 1a.5.5 0 0 0-.5-.5h-.5v2h.5a.5.5 0 0 0 .5-.5V6Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])], 10, h);
}
const H = /* @__PURE__ */ s(c, [["render", m]]);
export {
  H as default
};
//# sourceMappingURL=switch-to-hd.js.map
